"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserRole = exports.isNewUser = void 0;
const isNewUser = idToken => {
  try {
    const decodedTokenPayload = JSON.parse(atob(idToken.split('.')[1]));
    return !!decodedTokenPayload.newUser;
  } catch (_) {
    return false;
  }
};
exports.isNewUser = isNewUser;
const getUserRole = idToken => {
  try {
    const decodedTokenPayload = JSON.parse(atob(idToken.split('.')[1]));
    return decodedTokenPayload.jobTitle;
  } catch (_) {
    return undefined;
  }
};
exports.getUserRole = getUserRole;
//# sourceMappingURL=index.js.map